export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport-home-banner.vue?vue&type=template&id=22964442"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/sport-home-banner.vue?vue&type=template&id=22964442
// module id = ghr4
// module chunks = 0